import type { RefObject } from 'react';

export const setCursorPosition = (ref: RefObject<HTMLInputElement> | undefined) => {
    if (!ref || !ref.current) {
        return;
    }

    const { selectionEnd, selectionStart } = ref.current;

    if (selectionStart !== null && selectionEnd !== null) {
        setTimeout(() => ref.current?.setSelectionRange(selectionStart, selectionEnd), 0);
    }
};
